import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useState, useId } from 'react';
function ChevronIcon() {
    return (_jsx("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-hidden": "true", children: _jsx("path", { d: "M3.5 5.5l3.5 3.5 3.5-3.5", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
}
export const Select = forwardRef(({ label, hint, error, options = [], placeholder, id: idProp, disabled, onFocus, onBlur, children, style, ...props }, ref) => {
    const autoId = useId();
    const id = idProp ?? autoId;
    const hintId = `${id}-hint`;
    const [focused, setFocused] = useState(false);
    const borderColor = focused
        ? error
            ? '#ef4444'
            : 'var(--color-accent-primary, #00d4aa)'
        : error
            ? 'rgba(239,68,68,0.5)'
            : 'var(--color-border, #2a2a2e)';
    const focusShadow = focused
        ? error
            ? '0 0 0 3px rgba(239,68,68,0.15)'
            : '0 0 0 3px rgba(0,212,170,0.12)'
        : 'none';
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: '6px', ...style }, children: [label && (_jsx("label", { htmlFor: id, style: {
                    fontSize: 'var(--text-caption, 13px)',
                    fontWeight: 500,
                    color: disabled ? 'var(--color-text-faint)' : 'var(--color-text-muted)',
                    fontFamily: 'var(--font-body)',
                    userSelect: 'none',
                }, children: label })), _jsxs("div", { style: { position: 'relative', display: 'flex', alignItems: 'center' }, children: [_jsxs("select", { ref: ref, id: id, disabled: disabled, "aria-describedby": hint || error ? hintId : undefined, "aria-invalid": error ? true : undefined, onFocus: (e) => {
                            setFocused(true);
                            onFocus?.(e);
                        }, onBlur: (e) => {
                            setFocused(false);
                            onBlur?.(e);
                        }, style: {
                            width: '100%',
                            height: '44px',
                            padding: '0 40px 0 14px',
                            background: disabled ? 'var(--color-bg-base)' : 'var(--color-bg-input, #0f0f11)',
                            border: `1px solid ${borderColor}`,
                            borderRadius: 'var(--radius-md, 8px)',
                            color: disabled ? 'var(--color-text-faint)' : 'var(--color-text)',
                            fontFamily: 'var(--font-body)',
                            fontSize: 'var(--text-body, 15px)',
                            outline: 'none',
                            boxShadow: focusShadow,
                            transition: 'border-color 150ms ease, box-shadow 150ms ease',
                            opacity: disabled ? 0.5 : 1,
                            cursor: disabled ? 'not-allowed' : 'pointer',
                            appearance: 'none',
                            WebkitAppearance: 'none',
                        }, ...props, children: [placeholder && (_jsx("option", { value: "", disabled: true, children: placeholder })), options.map((opt) => (_jsx("option", { value: opt.value, disabled: opt.disabled, children: opt.label }, opt.value))), children] }), _jsx("span", { "aria-hidden": "true", style: {
                            position: 'absolute',
                            right: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            color: 'var(--color-text-faint)',
                            pointerEvents: 'none',
                            transition: 'transform 150ms ease',
                            transform: focused ? 'rotate(180deg)' : 'rotate(0deg)',
                        }, children: _jsx(ChevronIcon, {}) })] }), (hint || error) && (_jsx("p", { id: hintId, style: {
                    fontSize: 'var(--text-xs, 12px)',
                    color: error ? '#ef4444' : 'var(--color-text-faint)',
                    fontFamily: 'var(--font-body)',
                    margin: 0,
                }, children: error ?? hint }))] }));
});
Select.displayName = 'Select';
//# sourceMappingURL=Select.js.map